async function getCategoryCollectionData() {
  fetch("https://w3g1867be0.execute-api.us-west-2.amazonaws.com/Prod/get-all-category-collections", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  })
    .then((response) => {
      if (!response.ok) throw new Error("Fetch not successful");
      return response.json();
    })
    .then((data) => {
      localStorage.setItem(`${LOCAL_STORAGE_VERSION}category-data`, JSON.stringify(data));
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

/**
 * Fetch category and products data from lambda using GraphQL Admin API
 * Caution: Prone to rate limiting when ran in parallel
 * @param {string} handle
 * @param {string} filterTag
 * @returns
 */
async function getCollectionDataFromAPI(handle, filterTag) {
  const data = await fetch(
    "https://w3g1867be0.execute-api.us-west-2.amazonaws.com/Prod/get-vehicle-collection-products",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ handle: handle, tag: filterTag }),
    }
  )
    .then((response) => response.json())
    .then((data) => data || [])
    .catch((error) => {
      console.error("Error:", error);
    });
  return data;
}

const categoryData = localStorage.getItem(`${LOCAL_STORAGE_VERSION}category-data`);

if (categoryData === "undefined" || categoryData === null) {
  getCategoryCollectionData();
}

async function getCollectionData(handle) {
  console.log("GETTING COLLECTION DATA");

  // Fetch category data first
  const categoryData = localStorage.getItem(`${LOCAL_STORAGE_VERSION}category-data`);
  if (categoryData === "undefined" || categoryData === null) getCategoryCollectionData();

  // Get product data from cache if exists
  const productData = localStorage.getItem(`${LOCAL_STORAGE_VERSION}product-data`);
  if (productData) return JSON.parse(productData);

  // Get product data from liquid if it exists
  let collectionData = getCollectionDataFromScriptTagId("compatible-products");

  // Fallback: Use api to fetch products
  const filterTag = getVehicleTag();
  if (!collectionData) collectionData = await getCollectionDataFromAPI(handle, filterTag);

  // Merge universal collection data
  const universalCollectionData = getCollectionDataFromScriptTagId("universal-products");
  collectionData = joinCollectionData(collectionData, universalCollectionData);

  // Merge 2008+ collection data
  const year = parseInt(existingYearData);
  const twoThousandEightCollectionData = getCollectionDataFromScriptTagId("universal-products-2008");
  if (year >= 2008) collectionData = joinCollectionData(collectionData, twoThousandEightCollectionData);

  // Save to cache
  localStorage.setItem(`${LOCAL_STORAGE_VERSION}product-data`, JSON.stringify(collectionData));

  return collectionData;
}

async function getOrderedCategories(handle) {
  const data = await fetch("https://w3g1867be0.execute-api.us-west-2.amazonaws.com/Prod/get-collection-by-handle", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ handle: handle }),
  })
    .then((response) => response.json())
    .then((data) => data || [])
    .catch((error) => {
      console.error("Error:", error);
    });
  return data;
}

/**
 * Get collection data from script tag's id
 * @param {string} id
 */
function getCollectionDataFromScriptTagId(id) {
  const elem = document.getElementById(id);
  if (!elem) return null;
  const jsonData = elem.innerHTML.replaceAll("|||,{", "{").replaceAll("null", `""`).replaceAll("[|||]", "[]") || "{}";
  return JSON.parse(jsonData).collection;
}

/**
 * Join two collection data array
 * @param {object[]} collectionData
 * @param {object[]} newCollectionData
 * @returns {object[]}
 */
function joinCollectionData(collectionData, newCollectionData) {
  newCollectionData.forEach((collection) => {
    const existingCollection = collectionData.find(
      (existingCollection) => existingCollection.category.handle === collection.category.handle
    );
    if (existingCollection) {
      existingCollection.products = [...existingCollection.products, ...collection.products];
    } else {
      collectionData = [...collectionData, collection];
    }
  });

  return collectionData;
}

const productData = localStorage.getItem(`${LOCAL_STORAGE_VERSION}product-data`);
const isCollectionPage = location.pathname.includes("/collections/");
const isHomePage = location.pathname === "/";

if ((productData === "undefined" || productData === null) && !isCollectionPage && !isHomePage) {
  const handle = getVehicleHandle();
  if (handle) getCollectionData(handle);
}

console.log("vehicle-products.js loaded");
